import { Flashcard } from '../../types';

export const flashcards: Flashcard[] = [
  // Grundsätze (5 Karten)
  {
    id: 'fc-grundsaetze-1',
    category: 'grundsaetze',
    question: 'Nenne die 4 Grundsätze der EU!',
    answer: '1. Gemeinsame Werte & Ziele\n2. Wirtschaftliche Zusammenarbeit\n3. Politische Zusammenarbeit\n4. Zusammenhalt in Krisenzeiten',
    speech: 'Die 4 Grundsätze sind: 1. Gemeinsame Werte und Ziele, 2. Wirtschaftliche Zusammenarbeit, 3. Politische Zusammenarbeit, 4. Zusammenhalt in Krisenzeiten.',
  },
  {
    id: 'fc-grundsaetze-2',
    category: 'grundsaetze',
    question: "Was bedeutet 'Gemeinsame Werte und Ziele'?",
    answer: 'Werte: Freiheit, Demokratie, Menschenrechte\nZiele: Frieden, Wohlstand, Wirtschaftswachstum',
    speech: 'Gemeinsame Werte und Ziele bedeutet: Die EU-Länder teilen Werte wie Freiheit, Demokratie und Menschenrechte. Die Ziele sind Frieden, Wohlstand und Wirtschaftswachstum.',
  },
  {
    id: 'fc-grundsaetze-3',
    category: 'grundsaetze',
    question: "Was bedeutet 'Wirtschaftliche Zusammenarbeit'?",
    answer: 'Waren, Geld, Personen bewegen sich frei.\nKeine Zölle. Gemeinsamer Markt.',
    speech: 'Wirtschaftliche Zusammenarbeit bedeutet: Waren, Geld und Personen bewegen sich frei über Grenzen. Es gibt keine Zölle zwischen EU-Ländern.',
  },
  {
    id: 'fc-grundsaetze-4',
    category: 'grundsaetze',
    question: "Was bedeutet 'Politische Zusammenarbeit'?",
    answer: 'Gemeinsame Regeln und Gesetze für alle.\nFestgelegt vom EU-Parlament.',
    speech: 'Politische Zusammenarbeit bedeutet: Gemeinsame Regeln und Gesetze, die für alle gelten. Sie werden vom Europäischen Parlament festgelegt.',
  },
  {
    id: 'fc-grundsaetze-5',
    category: 'grundsaetze',
    question: "Was bedeutet 'Zusammenhalt in Krisenzeiten'?",
    answer: 'Bei Naturkatastrophen oder Krieg helfen sich die Länder gegenseitig.',
    speech: 'Zusammenhalt in Krisenzeiten bedeutet: Bei Naturkatastrophen oder Krieg halten die EU-Länder zusammen und unterstützen sich gegenseitig.',
  },

  // Vorteile (5 Karten)
  {
    id: 'fc-vorteile-1',
    category: 'vorteile',
    question: 'Nenne 3 Vorteile der EU!',
    answer: '1. Freies Reisen & Arbeiten\n2. Gemeinsame Währung (Euro)\n3. Frieden & Stabilität',
    speech: 'Drei Vorteile der EU sind: 1. Freies Reisen und Arbeiten, 2. Gemeinsame Währung Euro, 3. Frieden und Stabilität.',
  },
  {
    id: 'fc-vorteile-2',
    category: 'vorteile',
    question: 'Was ist der EU-Binnenmarkt?',
    answer: 'Wie ein großes Land ohne Grenzen.\nKeine Zölle. Freier Handel.',
    speech: 'Der Binnenmarkt funktioniert wie ein großes Land ohne Grenzen. Waren können ohne Zölle zwischen EU-Ländern gehandelt werden.',
  },
  {
    id: 'fc-vorteile-3',
    category: 'vorteile',
    question: 'Was bedeutet "Frieden und Stabilität" als EU-Vorteil?',
    answer: 'Seit Jahrzehnten kein Krieg zwischen EU-Ländern.\nZusammenarbeit fördert Frieden.',
    speech: 'Frieden und Stabilität bedeutet: Seit Jahrzehnten gibt es keinen Krieg mehr zwischen EU-Mitgliedsländern. Die enge Zusammenarbeit hat dazu beigetragen.',
  },
  {
    id: 'fc-vorteile-4',
    category: 'vorteile',
    question: 'Was bedeutet "Menschenrechte" als EU-Vorteil?',
    answer: 'EU schützt Grundfreiheiten.\nHohe Standards für Demokratie und Rechtsstaatlichkeit in allen Ländern.',
    speech: 'Die EU setzt sich stark für den Schutz der Menschenrechte ein. In allen Mitgliedsländern gelten hohe Standards für Demokratie und Rechtsstaatlichkeit.',
  },
  {
    id: 'fc-vorteile-5',
    category: 'vorteile',
    question: 'Nenne alle 5 Vorteile der EU!',
    answer: '1. Freies Reisen & Arbeiten\n2. Gemeinsame Währung (Euro)\n3. Frieden & Stabilität\n4. Binnenmarkt\n5. Menschenrechte',
    speech: 'Die 5 Vorteile der EU sind: 1. Freies Reisen und Arbeiten, 2. Gemeinsame Währung Euro, 3. Frieden und Stabilität, 4. Binnenmarkt, 5. Menschenrechte.',
  },

  // Nachteile (2 Karten)
  {
    id: 'fc-nachteile-1',
    category: 'nachteile',
    question: 'Nenne die 3 Nachteile der EU!',
    answer: '1. Bürokratie\n2. Souveränitätsverlust\n3. Ungleiche wirtschaftliche Entwicklung',
    speech: 'Die 3 Nachteile der EU sind: 1. Bürokratie, 2. Souveränitätsverlust, 3. Ungleiche wirtschaftliche Entwicklung.',
  },
  {
    id: 'fc-nachteile-2',
    category: 'nachteile',
    question: 'Was ist der Brexit?',
    answer: '2020 trat Großbritannien aus der EU aus.\nGrund: Wollten Souveränität zurück.',
    speech: 'Der Brexit war der Austritt Großbritanniens aus der EU im Jahr 2020. Viele Briten wollten ihre nationale Souveränität zurückhaben.',
  },

  // Mitglieder (8 Karten)
  {
    id: 'fc-mitglieder-1',
    category: 'mitglieder',
    question: 'Wie viele Mitgliedsstaaten hat die EU?',
    answer: '27 Mitgliedsstaaten',
    speech: 'Die EU hat 27 Mitgliedsstaaten.',
  },
  {
    id: 'fc-mitglieder-2',
    category: 'mitglieder',
    question: 'Welche 6 Länder gründeten die EGKS?',
    answer: 'Belgien, Deutschland, Frankreich, Italien, Luxemburg, Niederlande',
    speech: 'Die 6 Gründerstaaten der EGKS waren: Belgien, Deutschland, Frankreich, Italien, Luxemburg und die Niederlande.',
  },
  {
    id: 'fc-mitglieder-3',
    category: 'mitglieder',
    question: 'In welcher Region liegt Österreich?',
    answer: 'Mitteleuropa – zusammen mit Deutschland, Polen, Tschechien, Slowakei, Ungarn, Slowenien und Kroatien (8 Länder)',
    speech: 'Österreich liegt in Mitteleuropa. Die 8 Länder sind: Österreich, Deutschland, Polen, Tschechien, Slowakei, Ungarn, Slowenien und Kroatien.',
  },
  {
    id: 'fc-mitglieder-4',
    category: 'mitglieder',
    question: 'Welche 5 Länder gehören zu Westeuropa?',
    answer: 'Frankreich, Belgien, Niederlande, Luxemburg, Irland',
    speech: 'Die 5 westeuropäischen EU-Länder sind: Frankreich, Belgien, Niederlande, Luxemburg und Irland.',
  },
  {
    id: 'fc-mitglieder-5',
    category: 'mitglieder',
    question: 'Welche 3 Länder gehören zu Nordeuropa?',
    answer: 'Schweden, Finnland, Dänemark',
    speech: 'Die 3 nordeuropäischen EU-Länder sind: Schweden, Finnland und Dänemark.',
  },
  {
    id: 'fc-mitglieder-6',
    category: 'mitglieder',
    question: 'Welche 6 Länder gehören zu Südeuropa?',
    answer: 'Italien, Spanien, Portugal, Griechenland, Malta, Zypern',
    speech: 'Die 6 südeuropäischen EU-Länder sind: Italien, Spanien, Portugal, Griechenland, Malta und Zypern.',
  },
  {
    id: 'fc-mitglieder-7',
    category: 'mitglieder',
    question: 'Welche 3 Länder gehören zum Baltikum?',
    answer: 'Estland, Lettland, Litauen',
    speech: 'Die 3 baltischen EU-Länder sind: Estland, Lettland und Litauen.',
  },
  {
    id: 'fc-mitglieder-8',
    category: 'mitglieder',
    question: 'Welche 2 Länder gehören zu Südosteuropa?',
    answer: 'Rumänien und Bulgarien',
    speech: 'Die 2 südosteuropäischen EU-Länder sind: Rumänien und Bulgarien.',
  },

  // Aufgaben (4 Karten)
  {
    id: 'fc-aufgaben-1',
    category: 'aufgaben',
    question: 'Warum wurde die EGKS 1951 gegründet?',
    answer: 'Damit Ressourcen nicht ins Militär gehen → Friedenssicherung!',
    speech: 'Die EGKS wurde 1951 gegründet, damit Ressourcen wie Kohle und Stahl nicht ins Militär gehen. Das Ziel war Friedenssicherung.',
  },
  {
    id: 'fc-aufgaben-2',
    category: 'aufgaben',
    question: 'Wann wurde die EU gegründet und durch welchen Vertrag?',
    answer: '1993 durch den Vertrag von Maastricht',
    speech: 'Die EU wurde 1993 durch den Vertrag von Maastricht gegründet.',
  },
  {
    id: 'fc-aufgaben-3',
    category: 'aufgaben',
    question: 'Was war das Ziel der EWG 1957?',
    answer: 'Einen gemeinsamen Markt schaffen.',
    speech: 'Das Ziel der EWG war es, einen gemeinsamen Markt zu schaffen – also freien Handel zwischen den Mitgliedsländern.',
  },
  {
    id: 'fc-aufgaben-4',
    category: 'aufgaben',
    question: 'Wie viele Länder nutzen den Euro?',
    answer: '20 Länder. Vorteil: Leichteres Reisen & Handel.',
    speech: '20 EU-Länder nutzen den Euro als Währung. Der Hauptvorteil ist leichteres Reisen und einfacherer Handel.',
  },
  {
    id: 'fc-aufgaben-5',
    category: 'aufgaben',
    question: 'Welche 2 Gemeinschaften entstanden durch die Römischen Verträge 1957?',
    answer: 'EWG (Europäische Wirtschaftsgemeinschaft)\nEuratom (Europäische Atomgemeinschaft)',
    speech: 'Durch die Römischen Verträge 1957 entstanden die EWG, die Europäische Wirtschaftsgemeinschaft, und Euratom, die Europäische Atomgemeinschaft.',
  },

  // Länder (5 Karten)
  {
    id: 'fc-laender-1',
    category: 'laender',
    question: 'Wann ist Österreich der EU beigetreten?',
    answer: '1995 – zusammen mit Schweden und Finnland',
    speech: 'Österreich ist 1995 der EU beigetreten, zusammen mit Schweden und Finnland.',
  },
  {
    id: 'fc-laender-2',
    category: 'laender',
    question: 'Was ist das Besondere an Deutschland in der EU?',
    answer: 'Größtes EU-Land mit meisten Einwohnern.\nGründerstaat und stärkste Wirtschaft.',
    speech: 'Deutschland ist das größte EU-Land mit den meisten Einwohnern. Es ist ein Gründerstaat und hat die stärkste Wirtschaft in der EU.',
  },
  {
    id: 'fc-laender-3',
    category: 'laender',
    question: 'Wo sitzt das EU-Parlament?',
    answer: 'In Straßburg (Frankreich)',
    speech: 'Das EU-Parlament hat seinen Sitz in Straßburg, einer Stadt in Frankreich.',
  },
  {
    id: 'fc-laender-4',
    category: 'laender',
    question: "Warum heißen die 'Römischen Verträge' so?",
    answer: 'Weil sie 1957 in Rom (Italien) unterzeichnet wurden.',
    speech: 'Die Römischen Verträge heißen so, weil sie 1957 in Rom, der Hauptstadt Italiens, unterzeichnet wurden.',
  },
  {
    id: 'fc-laender-5',
    category: 'laender',
    question: 'Wann ist Polen der EU beigetreten?',
    answer: '2004 – bei der großen EU-Osterweiterung (10 neue Länder!)',
    speech: 'Polen ist 2004 der EU beigetreten, bei der großen EU-Osterweiterung mit 10 neuen Ländern gleichzeitig.',
  },

  // Abkürzungen (4 Karten)
  {
    id: 'fc-abkuerzung-1',
    category: 'abkuerzungen',
    question: 'Wofür steht EU?',
    answer: 'Europäische Union',
    speech: 'EU steht für Europäische Union.',
  },
  {
    id: 'fc-abkuerzung-2',
    category: 'abkuerzungen',
    question: 'Wofür steht EGKS?',
    answer: 'Europäische Gemeinschaft für Kohle und Stahl\n(gegründet 1951)',
    speech: 'EGKS steht für Europäische Gemeinschaft für Kohle und Stahl. Sie wurde 1951 gegründet.',
  },
  {
    id: 'fc-abkuerzung-3',
    category: 'abkuerzungen',
    question: 'Wofür steht EWG?',
    answer: 'Europäische Wirtschaftsgemeinschaft\n(gegründet 1957, Römische Verträge)',
    speech: 'EWG steht für Europäische Wirtschaftsgemeinschaft. Sie wurde 1957 durch die Römischen Verträge gegründet.',
  },
  {
    id: 'fc-abkuerzung-4',
    category: 'abkuerzungen',
    question: 'Wofür steht Euratom?',
    answer: 'Europäische Atomgemeinschaft\n(gegründet 1957, Römische Verträge)',
    speech: 'Euratom steht für Europäische Atomgemeinschaft. Sie wurde zusammen mit der EWG 1957 gegründet.',
  },
];

// Kategorien für Flashcards
export const flashcardCategories = {
  grundsaetze: { label: '📋 Grundsätze', color: '#4caf50' },
  vorteile: { label: '✅ Vorteile', color: '#42a5f5' },
  nachteile: { label: '❌ Nachteile', color: '#ef5350' },
  mitglieder: { label: '🗺️ Mitglieder', color: '#ab47bc' },
  aufgaben: { label: '📝 Aufgaben', color: '#ff9800' },
  laender: { label: '🏛️ Länder', color: '#26c6da' },
  abkuerzungen: { label: '🔤 Abkürzungen', color: '#78909c' },
};
